<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconzhanghao"></i>
      账号管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="keyword"
              placeholder="手机号"
              class="margin-right-sm"
          ></el-input>
          <el-select v-model="state" placeholder="状态" class="margin-right-sm">
            <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
        <el-button type="primary" @click="accountDialog = true">
          <p class="flex align-center font-size">
            <i class="iconfont iconxinzeng margin-right-xs"></i>新增帐号
          </p>
        </el-button>
      </div>
      <div class="table-warpper">
        <el-table
            :data="accountList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column width="70" type="index" align="center" label="序号">
          </el-table-column>
          <el-table-column label="账号名称">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.admin_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手机号码">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.admin_phone }}
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column label="角色">-->
<!--            <template slot-scope="scope">-->
<!--              <div class="table-item">-->
<!--                {{ scope.row.role_name }}-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.add_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.status === 0 ? "停用" : "正常" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="380">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row)"
                >编辑
                </el-button>
                <el-button
                    size="medium"
                    type="danger"
                    @click="deleteItem(scope.row.aid)"
                >删除
                </el-button>
                <el-button
                    size="medium"
                    type="warning"
                    @click="closeItem(scope.row.aid)"
                    v-if="scope.row.status === 1"
                >停用
                </el-button>
                <el-button
                    size="medium"
                    type="primary"
                    @click="openItem(scope.row.aid)"
                    v-if="scope.row.status === 0"
                >启用
                </el-button>
                <el-button
                    size="medium"
                    type="primary"
                    @click="initialItem(scope.row.aid)"
                >初始化密码
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="accountList.length > 0"
            class="page-all"
            background
            @current-change="setPage"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <accountDialog
        :setId="setId"
        :setItem="setItem"
        :accountDialog="accountDialog"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {userlist, userSet, userPass, userDel} from "@/api/admin";
import accountDialog from "@/views/admin/page/dialog/accountDialog";


export default {
  name: "account",
  components: {
    accountDialog
  },
  data() {
    return {
      keyword: "",
      state: "",
      stateOptions: [
        {
          value: "",
          label: "全部状态"
        },
        {
          value: "1",
          label: "正常"
        },
        {
          value: "0",
          label: "停用"
        }
      ],
      accountList: [],
      page: 1,
      total: 0,
      limit: 10,
      setId: 0,
      setItem: {},
      accountDialog: false
    };
  },
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：系统管理 > <span>帐号管理</span>",
        false
    );
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await userlist(
          this.keyword,
          this.state === ''?'':Number(this.state),
          this.page,
          this.limit
      );
      _list.data.list.map(item=>{
        item.add_time = this.$tools.ZHDate(new Date(item.add_time))
      })
      this.accountList = _list.data.list;
      this.total = _list.data.count;
    },
    setPage() {
      this.getList();
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.aid;
      this.accountDialog = true;
    },
    deleteItem(id) {
      this.$confirm("确定要删除该账户吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await userDel(id);
      if (this.accountList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    },
    closeItem(id) {
      this.$confirm("确定要停用该账户吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureClose(id);
      });
    },
    async sureClose(id) {
      let _state = await userSet(id, 0);
      this.getList();
      this.$message.success(_state.msg);
    },
    openItem(id) {
      this.$confirm("确定要启用该账户吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureOpen(id);
      });
    },
    async sureOpen(id) {
      let _state = await userSet(id, 1);
      this.getList();
      this.$message.success(_state.msg);
    },
    initialItem(id) {
      this.$confirm("确定要初始化该账户的密码吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureInitial(id);
      });
    },
    async sureInitial(id) {
      let _state = await userPass(id);
      this.$message.success(_state.msg);
    },
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.accountDialog = false;
        if (this.setId) {
          this.getList();
        } else {
          this.page = 1;
          this.getList();
        }
      } else {
        this.setId = 0;
        this.setItem = {};
        this.accountDialog = false;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
